var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import GlobalSearchApi from "../../core/api/globalSearchApi";
import { GET_OVERVIEW_SEARCH_REQUEST, GET_OVERVIEW_SEARCH_SUCCESS, GET_OVERVIEW_SEARCH_FAILURE, CLEAR_OVERVIEW_SEARCH } from "./types";
export const getOverviewSearchRequest = (params) => ({
    type: GET_OVERVIEW_SEARCH_REQUEST,
    payload: params,
});
export const getOverviewSearchSuccess = (data) => ({
    type: GET_OVERVIEW_SEARCH_SUCCESS,
    payload: data,
});
export const getOverviewSearchFailure = (error) => ({
    type: GET_OVERVIEW_SEARCH_FAILURE,
    payload: error,
});
export const clearOverviewSearch = () => ({
    type: CLEAR_OVERVIEW_SEARCH,
});
export function fetchOverviewGlobalSearch(params) {
    const { searchType, keyword, limit = 10, signal } = params;
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        dispatch(getOverviewSearchRequest({ searchType, keyword, limit }));
        try {
            const data = yield GlobalSearchApi.searchOverview({
                searchType,
                keyword,
                limit,
                signal,
            });
            const safe = Array.isArray(data) ? data : [];
            dispatch(getOverviewSearchSuccess(safe));
            return safe;
        }
        catch (err) {
            const message = (err && (err.message || err.error || err.toString())) ||
                "Failed to fetch global search results.";
            dispatch(getOverviewSearchFailure(message));
            throw err;
        }
    });
}
